import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common";
var NavigationService = /** @class */ (function () {
    function NavigationService(router, activeRoute, location) {
        this.router = router;
        this.activeRoute = activeRoute;
        this.location = location;
        this.queryRegex = new RegExp(/([^\?]+)(\?.*)?/i);
        this.forceNavigate = new Subject();
    }
    /**
     * Navigate to a route according given options
     * @param data navigation options
     */
    NavigationService.prototype.navigate = function (data) {
        var _type = data.type || null;
        switch (_type) {
            case 'basic':
                this.navigateBySteps(data.stepsBack || 1);
                break;
            case 'parent':
                this.navigateToParent(data);
                break;
            case 'basicWithoutQuery':
                this.setSteps(data.stepsBack || 1);
                break;
            default:
                this.location.back();
                break;
        }
    };
    /**
     * Navigate back to a route indicanting
     * the amount of steps to go back
     * @param steps Number of steps to go back
     */
    NavigationService.prototype.navigateBySteps = function (steps) {
        var _this = this;
        this.activeRoute.queryParams.subscribe(function (params) {
            var _url = _this.router.url.split('/')
                .slice(0, _this.router.url.split('/').length - steps)
                .join('/');
            _this.router.navigate([_url], { queryParams: params });
        }).unsubscribe();
    };
    NavigationService.prototype.setSteps = function (steps) {
        var _url = this.router.url.split('/')
            .slice(0, this.router.url.split('/').length - steps)
            .join('/');
        this.router.navigate([_url]);
    };
    /*
    * Navigate to a parent route
    */
    NavigationService.prototype.navigateToParent = function (data) {
        var _option = this.router.url.split('/')[data.stepParams];
        var _url = data.parentUrl.replace(':val', _option);
        var url = _url.split('?').slice(0, 1).join('');
        var queryString = this.router.url.substring(_url.indexOf('?') + 1);
        this.router.navigate([url], {
            queryParamsHandling: 'merge'
        });
    };
    NavigationService.prototype.parseQueryString = function (queryString) {
        var params = {};
        var queries = '';
        var temp = '';
        var i = 0;
        var l = 0;
        if (queryString.indexOf('/') !== -1)
            return {};
        // Split into key/value pairs
        queries = queryString.split('&');
        // Convert the array of strings into an object
        for (i = 0, l = queries.length; i < l; i++) {
            temp = queries[i].split('=');
            params[temp[0]] = temp[1];
        }
        return params || {};
    };
    NavigationService.ngInjectableDef = i0.defineInjectable({ factory: function NavigationService_Factory() { return new NavigationService(i0.inject(i1.Router), i0.inject(i1.ActivatedRoute), i0.inject(i2.Location)); }, token: NavigationService, providedIn: "root" });
    return NavigationService;
}());
export { NavigationService };
